import {
    GET_ALL_BUILDINGS,
    GET_MANAGER_BUILDING,
    BED_SUMMARY_PIECHART,
    GET_BEDS_BY_BUILDINGID,
    GET_BEDS_BY_COLOR_FILTERS,
    SUCCESS_RESPONSE,
    FAILURE_RESPONSE,
    CANCEL_CHECKOUT,
    GET_BEDINFO,
    CHANGE_BED,
    EDIT_DUE,
    FORCE_CHECKOUT,
    AVAILABEL_BEDSBY_BUILDINGID,
    LOADING,
    BUILDING_SUMMARY,
    MAKE_FALSE
} from '../actionTypes/RatActionTypes';
const initialState={
   allBuildings:[],
   building:[],
   piechartSummary:[],
   bedsByBuilding:[],
   loading:false,
   availableBeds:[],
   changeBedStatus:false,
   editDue:false,
   forceCheck:false,
   buildingSummary:[],
   cancelCheckouts:false

}
export const RatReducer=(state=initialState,action)=>{
switch(action.type)
{
    case GET_ALL_BUILDINGS:
        return {...state,allBuildings: action.payload};
    case GET_MANAGER_BUILDING:
        return {...state,building: action.payload} 
    case BED_SUMMARY_PIECHART:
        return {...state,piechartSummary:action.payload}  
    case GET_BEDS_BY_BUILDINGID:
        return {...state,bedsByBuilding:action.payload}
    case AVAILABEL_BEDSBY_BUILDINGID:
        return {...state,availableBeds:action.payload}
    case CHANGE_BED:
        console.log(action.payload.status)
        return{...state,changeBedStatus:action.payload.status}
    case GET_BEDINFO:
       return  {...state,bedInfo:action.payload}
    case GET_BEDS_BY_COLOR_FILTERS:
        return {...state,bedsByBuilding:action.payload}  
    case EDIT_DUE:
        return{...state,editDue:action.payload.status}  
    case FORCE_CHECKOUT:
        console.log(action.payload.status);
        return{...state,forceCheck:action.payload.status}
    case BUILDING_SUMMARY:
        return {...state,buildingSummary:action.payload.data}
    case LOADING:
        return {...state,loading:action.payload}   
    case MAKE_FALSE:
        return {...state,editDue:false,changeBedStatus:false,forceCheck:false,bedInfo:null,cancelCheckouts:false} 
        case CANCEL_CHECKOUT:
      return {...state,cancelCheckout:action.payload,cancelCheckouts:action.payload.status} 
    default:
        return state;    
}
}